"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonLoader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LoadingScreen = require("../LoadingScreen.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ButtonLoader = ({
  width,
  height,
  radius,
  theme,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_LoadingScreen.StyledListItem, _extends({}, props, {
    width: width,
    height: height,
    radius: radius,
    theme: theme
  }));
};

exports.ButtonLoader = ButtonLoader;
ButtonLoader.defaultProps = {
  width: '76px',
  height: '30px',
  radius: '30px'
};
ButtonLoader.propTypes = {
  /**
   *  button loader width
   * */
  width: _propTypes.default.string.isRequired,

  /**
   *  button loader height
   * */
  height: _propTypes.default.string.isRequired,

  /**
   *  button loader radius
   * */
  radius: _propTypes.default.string.isRequired,

  /**
   * white background :'light' ,
   * dark background:'dark'
   */
  theme: _propTypes.default.oneOf(['light', 'dark']),

  /** Color for loader */
  loaderColor: _propTypes.default.string
};